import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Modal, ModalHeader, ModalBody, Button, ModalFooter, FormGroup, Input, Label } from "reactstrap";

function ExpiryCertificateOptions(props) {
  const { isOpen, toggle, onOptionsSelected } = props;

  const convertDay = (date) => {
    const today = date ?? new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [endDate, setEndDate] = useState(convertDay);

  function handleSelection(e, choice) {
    onOptionsSelected(endDate);
  }

  return (
    <Modal isOpen={isOpen} size={"sm"} className={""} backdrop={"static"}>
      <ModalHeader>
        <FormattedMessage id="certificates.set_expiry" defaultMessage="Set certificate expiry date" />
      </ModalHeader>
      <ModalBody>
        <FormGroup row>
          <label htmlFor="name" className="col-sm-4 col-form-label">
            End date
          </label>
          <div className="col-sm-8">
            <input
              type="date"
              id="dateInput"
              value={endDate}
              className="form-control"
              onChange={(e) => {
                const dateValue = e.target.value;
                setEndDate(dateValue);
              }}
            />
          </div>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="dark" outline={true} onClick={toggle}>
          <FormattedMessage id="app.cancel" defaultMessage="Cancel" />
        </Button>
        <Button
          color="primary"
          outline={true}
          onClick={(e) => {
            e.preventDefault();
            handleSelection();
          }}
        >
          <FormattedMessage id="app.save" defaultMessage="Save" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ExpiryCertificateOptions;
